import Feathers from './feathers'

class ArticleLibrary extends Feathers {

    searchWord(keyword, pageindex = 1, pagesize = 18) {
        const url = `${ this.base }magazine/article/search?keyword=${
        keyword }&sortType=0&searchField=0&pagesize=${ pagesize }&pageindex=${ pageindex }`
        return this.request({
            url
        })
    }
    hightSearchArticle(pageNumber,pageSize,sortType,title,titleLogic,content,contentLogic,minDate,minDateLogic,
      maxDate,maxDateLogic,magazineName,magazineNameLogic,year,yearLogic,issue,issueLogic)
    {
      /*https://dspc.dps.qikan.com/api/magazine/article/search?
      pageNumber=1&pageSize=10[&itemCount=][&sortType=][&title=][&titleLogic=]
      [&titlePrecise=][&content=][&contentLogic=][&contentPrecise=][&column=]
      [&=columnLogic][&columnPrecise=][&minDate=][&minDateLogic=][&minDatePrecise=]
      [&maxDate=][&maxDateLogic=][&maxDatePrecise=][&magazineName=][&magazineNameLogic=]
      [&magazineNamePrecise=][&year=][&yearLogic=][&yearPrecise=][&issue=][&issueLogic=]
      [&issuePrecise=][&categoryCode=][&year=2021]*/
      let url =`${ this.base }magazine/article/search?pageNumber=${pageNumber}&pageSize=${pageSize}&sortType=${sortType}`;
      if(title!='title')
      {
         url+=`&title=${title}&titleLogic=${titleLogic}&titlePrecise=1`;
      }
      if(content!='content')
      {
         url+=`&content=${content}&contentLogic=${contentLogic}&contentPrecise=1`;
      }
      if(minDate!='minDate')
      {
         url+=`&minDate=${minDate}&minDateLogic=${minDateLogic}&minDatePrecise=0`;
      }
      if(maxDate!='maxDate')
      {
         url+=`&maxDate=${maxDate}&maxDateLogic=${maxDateLogic}&maxDatePrecise=0`;
      }
      if(magazineName!='magazineName')
      {
         url+=`&magazineName=${magazineName}&magazineNameLogic=${magazineNameLogic}&magazineNamePrecise=1`;
      }
      if(year!="0")
      {
         url+=`&year=${year}&yearLogic=${yearLogic}&yearPrecise=0`;
      }
      if(issue!="0")
      {
         url+=`&issue=${issue}&issueLogic=${issueLogic}&issuePrecise=0`;
      }
      return this.request({
            url: url
      })
   }
   simpleSearch(keyword,searchField,sortType,pageNumber,pagesize)
   {
      return this.request({
         url: `${ this.base }magazine/article/search?searchField=${searchField}&keyword=${keyword}&pageindex=${pageNumber}&pageSize=${pagesize}&sortType=${sortType}`
      })
   }
    //http://dspc.dps.qikan.com/api/magazine/article/search?keyword=%E8%AF%BB%E8%80%85&searchField=1&sortType=0&pageindex=1&pagesize=12&itemcount=15364
}

export default ArticleLibrary
